import { http } from "@/lib/http";
export function fetchHomepageSections() {
  return http.get("/api/homepage_layout/get").then((res) => res.data);
}
export function fetchHomepageSection(id) {
  return http.get(`/api/homepage_layout/edit/${id}`).then((res) => res.data);
}
export function updateHomepageSection(id, payload) {
  return http
    .put(`/api/homepage_layout/update/${id}`, payload)
    .then((res) => res.data);
}
export function uploadHomeSectionFile(file) {
  const data = new FormData();
  let url;
  if (file.type.includes("image")) {
    url = "/api/image_upload/home-section";
    data.append("imageFile", file);
  } else if (file.type.includes("video")) {
    url = "/api/video_upload/home-section";
    data.append("videoFile", file);
  } else {
    url = "/api/file_upload/home-section";
    data.append("file", file);
  }
  return http
    .post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.imageUrl);
}
